import { Slider, SliderSingleProps } from 'antd';
import moment from 'moment';
import { FC, useEffect, useState } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { useParams } from 'react-router-dom';

import { ChartOverViewRecruitmentOrganization } from '@/components/chart/ChartMoneyUser';
import { PieChartWorkerType } from '@/components/chart/PieChartWorkerType';
import { ProtectedComponent } from '@/components/molecules/ProtectedComponent';
import { TableTagCell } from '@/components/molecules/TableTagCell';
import { useOverviewResultDetail } from '@/modules/recruitment-organization/hooks/useOverviewResultDetail';
import { FormRecruitmentPlanModel, RecruitmentPlanModel } from '@/modules/recruitment-plan/models';
import { getClientDate } from '@/utils';

interface IProps {
  readonly permission: boolean;
  formMethods?: UseFormReturn<FormRecruitmentPlanModel, object>;
  readonly isSubmit?: boolean;
  readonly organization?: boolean;
  readonly recruitmentDetail?: RecruitmentPlanModel;
}

const OverviewResult: FC<IProps> = (props: IProps) => {
  const { id } = useParams();
  const marks: SliderSingleProps['marks'] = {
    0: '0',
    100: '100',
  };

  const { data } = useOverviewResultDetail(id || '');

  return (
    <ProtectedComponent hasAccess={props.permission}>
      <div className="row">
        <div className="col-12">
          <div className="card card-body">
            <h4>Thời gian triển khai chiến dịch</h4>
            {(() => {
              const start = moment(data?.start_date).startOf('day');
              const end = moment(data?.end_date).endOf('day');
              const totalDays = end.diff(start, 'days') + 1;
              const [currentTime, setCurrentTime] = useState(moment());

              useEffect(() => {
                const timer = setInterval(() => setCurrentTime(moment()), 1000);
                return () => clearInterval(timer);
              }, []);

              const duration = moment.duration(end.diff(currentTime));
              const isFinished = currentTime.isAfter(end);
              const isNotStarted = currentTime.isBefore(start);

              let countdownText = '';
              if (isFinished) {
                countdownText = 'Đã kết thúc';
              } else if (isNotStarted) {
                countdownText = `Chưa bắt đầu (còn ${Math.floor(moment.duration(start.diff(currentTime)).asDays())} ngày)`;
              } else {
                const d = Math.floor(duration.asDays());
                const h = duration.hours();
                const m = duration.minutes();
                const s = duration.seconds();
                countdownText = `Còn lại: ${d} ngày ${h} giờ ${m} phút ${s} giây`;
              }

              return (
                <p className="ps-5">
                  Từ {getClientDate(data?.start_date)} đến {getClientDate(data?.end_date)} | Tổng số
                  ngày: {totalDays}
                  <span className="text-danger ps-10">{countdownText}</span>
                </p>
              );
            })()}
          </div>
          <div className="card card-body">
            <h4>Tỉ lệ NLĐ đã đến làm</h4>
            <p>
              <span className="ps-5">
                Nam: {data?.result_by_gender.male} / {data?.result_by_gender.target_male}
              </span>
              <span className="ps-5">
                Nữ: {data?.result_by_gender.female} / {data?.result_by_gender.target_female}
              </span>
            </p>
            <Slider marks={marks} value={data?.target_percentage} />
          </div>

          <div className="card card-body">
            <ChartOverViewRecruitmentOrganization
              data={data?.result_by_team}
              dataMember={data?.result_by_member}
              organization={props.organization}
              totalData={(data?.result_by_gender.female || 0) + (data?.result_by_gender.male || 0)}
            />
          </div>

          <div className="card card-body">
            <h4>Phân loại % các data theo trạng thái</h4>
            <div className="row">
              <div className="col-12">
                <PieChartWorkerType data={data?.result_by_worker_type as any} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </ProtectedComponent>
  );
};

export { OverviewResult };
